import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import {
  FileCloneDriveGroup,
  FileCloneDriveGroupModel
} from '../domain/models/FileCloneDriveGroup'
import { CloneDatasource } from '../infra/CloneDatasource'

export const cloneDatasourceAdapter: CloneDatasource = {
  async cloneDataDrive(data, patientId: string): Promise<FileCloneDriveGroup> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/file-clone`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = FileCloneDriveGroupModel.parse(await response.json())
    return json
  }
}
